(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-collections"]) return;
  try {
    
/* Smooth scroll to in-page anchors with header offset — no jQuery */
document.addEventListener('click', function (event) {
  const link = event.target.closest('a[href^="#"]');
  if (!link) return;

  const href = link.getAttribute('href');
  if (!href || href === '#') return;

  const target = document.querySelector(href);
  if (!target) return;

  event.preventDefault();

  const header = document.querySelector('.header-main');
  const offset = header ? header.offsetHeight : 0;
  const top = target.getBoundingClientRect().top + window.pageYOffset - offset;

  window.scrollTo({ top, behavior: 'smooth' });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dawn13-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      if (!this.header) return; // ✅ guard

      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      // ✅ default bounds so .bottom/.top are always numbers
      this.headerBounds = { top: 0, bottom: 0 };

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)')
        .addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      // ✅ passive improves scroll on mobile
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.createObserver();
    }

    setHeaderHeight() {
      if (!this.header) return;
      document.documentElement.style.setProperty(
        '--header-height',
        `${this.header.offsetHeight}px`
      );
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      // ✅ guard if header missing
      if (!this.header) return;

      const observer = new IntersectionObserver((entries, obs) => {
        const entry = entries && entries[0];
        // ✅ fallback if intersectionRect is missing
        this.headerBounds = entry?.intersectionRect || this.header.getBoundingClientRect();
        obs.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (!this.header) return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      // ✅ ensure bounds exist even before observer resolves
      const boundsBottom =
        (typeof this.headerBounds.bottom === 'number' && this.headerBounds.bottom) ||
        this.header.getBoundingClientRect().bottom;

      const boundsTop =
        (typeof this.headerBounds.top === 'number' && this.headerBounds.top) ||
        0;

      if (scrollTop > this.currentScrollTop && scrollTop > boundsBottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > boundsBottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= boundsTop) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky'
      );
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate'
      );
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure?.close?.());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      // ✅ guard close() existence
      if (this.searchModal?.close) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      if (!this.header) return; // ✅ guard

      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      // ✅ ensure bounds always exist
      this.headerBounds = { top: 0, bottom: 0 };

      this.setHeaderHeight();

      window
        .matchMedia('(max-width: 990px)')
        .addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      // ✅ passive scroll for mobile safety
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.createObserver();
    }

    setHeaderHeight() {
      if (!this.header) return;
      document.documentElement.style.setProperty(
        '--header-height',
        `${this.header.offsetHeight}px`
      );
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      if (!this.header) return;

      const observer = new IntersectionObserver((entries, obs) => {
        const entry = entries && entries[0];
        this.headerBounds =
          entry?.intersectionRect || this.header.getBoundingClientRect();
        obs.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (!this.header) return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      const boundsBottom =
        typeof this.headerBounds.bottom === 'number'
          ? this.headerBounds.bottom
          : this.header.getBoundingClientRect().bottom;

      const boundsTop =
        typeof this.headerBounds.top === 'number'
          ? this.headerBounds.top
          : 0;

      if (scrollTop > this.currentScrollTop && scrollTop > boundsBottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > boundsBottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= boundsTop) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky'
      );
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate'
      );
    }

    closeMenuDisclosure() {
      this.disclosures =
        this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((d) => d?.close?.());
    }

    closeSearchModal() {
      this.searchModal =
        this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal?.close) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // ✅ Guarded menu close handler (this was unsafe before)
  const menuCloseBtn = document.querySelector('.menu-drawer .menu_close');
  const menuToggleBtn = document.querySelector('.header__icon--menu');

  if (menuCloseBtn && menuToggleBtn) {
    menuCloseBtn.addEventListener('click', () => {
      menuToggleBtn.dispatchEvent(new Event('click'));
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-section"] && !Shopify.designMode) return;
  try {
    
/* Vanilla slider for the hero section — no Liquid in JS */
(function () {
  // Scope to this section only
  var script = document.currentScript;
  var root = script ? script.closest('.hero-section') : document;
  if (!root) return;

  var slider = root.querySelector('[data-hero-slider]');
  if (!slider) return;

  var slides = Array.prototype.slice.call(slider.querySelectorAll('[data-hero-slide]'));
  var prevBtn = root.querySelector('.hero-prev');
  var nextBtn = root.querySelector('.hero-next');
  var dotsWrap = root.querySelector('.hero-dots');

  var index = 0;
  var total = slides.length;

  slider.style.transition = 'transform 300ms ease';
  slider.style.willChange = 'transform';

  // Build dots
  if (dotsWrap) {
    dotsWrap.innerHTML = '';
    slides.forEach(function (_, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('role', 'tab');
      b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      b.addEventListener('click', function () { goTo(i); });
      dotsWrap.appendChild(b);
    });
  }

  function updateUI() {
    slider.style.transform = 'translateX(-' + (index * 100) + '%)';

    if (dotsWrap) {
      Array.prototype.forEach.call(dotsWrap.children, function (d, i) {
        d.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    }

    if (prevBtn) prevBtn.disabled = index === 0;
    if (nextBtn) nextBtn.disabled = index === total - 1;

    slides.forEach(function (s, i) {
      s.setAttribute('aria-hidden', i === index ? 'false' : 'true');
    });
  }

  function goTo(i) {
    index = Math.max(0, Math.min(total - 1, i));
    updateUI();
  }

  prevBtn && prevBtn.addEventListener('click', function () { goTo(index - 1); });
  nextBtn && nextBtn.addEventListener('click', function () { goTo(index + 1); });

  // Hide nav if only one slide
  if (total <= 1) {
    prevBtn && prevBtn.setAttribute('hidden', 'hidden');
    nextBtn && nextBtn.setAttribute('hidden', 'hidden');
    dotsWrap && dotsWrap.setAttribute('hidden', 'hidden');
  }

  updateUI();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["showcase_slider"] && !Shopify.designMode) return;
  try {
    
/* Vanilla fade slider: autoplay=true, arrows=true, dots=false, fade=true, infinite by looping */
(function () {
  var script = document.currentScript;
  var root = script ? script.closest('.showcase-slider-section') : null;
  if (!root) return;

  var slider = root.querySelector('[data-showcase-slider]');
  if (!slider) return;

  var slides = Array.prototype.slice.call(slider.querySelectorAll('[data-showcase-slide]'));
  var prevBtn = root.querySelector('.showcase-prev');
  var nextBtn = root.querySelector('.showcase-next');

  var total = slides.length;
  if (!total) return;

  var idx = 0;
  var autoplayMs = 4000; // mimic slick autoplay defaultish cadence
  var timer = null;

  function setActive(i) {
    slides.forEach(function (s, n) {
      s.setAttribute('aria-hidden', n === i ? 'false' : 'true');
      if (n === i) {
        s.style.zIndex = 2;
      } else {
        s.style.zIndex = 1;
      }
    });
  }

  function goTo(i) {
    idx = (i + total) % total; // loop (infinite)
    setActive(idx);
    updateArrows();
  }

  function next() { goTo(idx + 1); }
  function prev() { goTo(idx - 1); }

  function startAutoplay() {
    if (timer || total < 2) return;
    timer = setInterval(next, autoplayMs);
  }

  function stopAutoplay() {
    if (!timer) return;
    clearInterval(timer);
    timer = null;
  }

  function updateArrows() {
    // Infinite behavior: never disable arrows (to match slick infinite)
    if (prevBtn) prevBtn.disabled = false;
    if (nextBtn) nextBtn.disabled = false;
  }

  // Init
  slides.forEach(function (s, i) {
    // stack slides; first visible
    s.style.position = 'absolute';
    s.style.inset = '0';
    s.setAttribute('aria-hidden', i === 0 ? 'false' : 'true');
    s.style.zIndex = i === 0 ? 2 : 1;
  });

  prevBtn && prevBtn.addEventListener('click', function () { stopAutoplay(); prev(); startAutoplay(); });
  nextBtn && nextBtn.addEventListener('click', function () { stopAutoplay(); next(); startAutoplay(); });

  // Pause on hover/focus like many sliders
  root.addEventListener('mouseenter', stopAutoplay);
  root.addEventListener('mouseleave', startAutoplay);
  root.addEventListener('focusin', stopAutoplay);
  root.addEventListener('focusout', startAutoplay);

  // Respect reduced motion: skip autoplay
  var prefersReduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!prefersReduce) startAutoplay();
})();

  } catch(e) { console.error(e); }
})();
})();
